
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: 'SubscriptionsPage',
}) 
export default class SubscriptionsPage extends Vue {
}
